import { useEffect, useMemo, useRef, useState } from 'react';
import { fetchStructureLogs } from '../services/structureLog.api';
import { normalizeStatus, normalizeReqType } from '../utils/structureLog.helpers';

export function useStructureLogs(initialDateRange) {
  const [dateRange, setDateRange] = useState(initialDateRange);
  const [raw, setRaw] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const initialDone = useRef(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const data = await fetchStructureLogs({ start: dateRange.start, end: dateRange.end });
        if (!alive) return;
        setRaw(Array.isArray(data) ? data : []);
      } catch {
        if (alive) setRaw([]);
      } finally {
        if (alive) setLoading(false);
        initialDone.current = true;
      }
    })();
    return () => { alive = false; };
  }, [dateRange.start, dateRange.end]); 

  useEffect(() => {
    if (!initialDone.current) return;
    let alive = true;
    (async () => {
      try {
        setRefreshing(true);
        const data = await fetchStructureLogs({ start: dateRange.start, end: dateRange.end });
        if (!alive) return;
        setRaw(Array.isArray(data) ? data : []);
      } catch {
        if (alive) setRaw([]);
      } finally {
        if (alive) setRefreshing(false);
      }
    })();
    return () => { alive = false; };
  }, [dateRange.start, dateRange.end]);

  const rows = useMemo(
    () =>
      raw.map((f, i) => ({
        id: i,
        fileName: f.filename ?? f.FileName ?? '',
        status: normalizeStatus(f.status),
        reqtype: normalizeReqType(f.reqtype),
        message: f.message ?? '',
        logDate: f.LogDate ?? f.logDate ?? null,
      })),
    [raw]
  );

  return { rows, dateRange, setDateRange, loading, refreshing };
}
